import { useFormatMessage } from '../../helpers/intl'

export const useChargerConnectivityTranslation = () => {
  const connectivityPeriods: string[] = [
    useFormatMessage('dashboard.chargerPage.listings.chargerConnectivity.last1hour', 'Last Hour (5-Min Interval)'),
    useFormatMessage('dashboard.chargerPage.listings.chargerConnectivity.last1day', 'Last 24 Hours (Hourly Interval)'),
    useFormatMessage('dashboard.chargerPage.listings.chargerConnectivity.last7days', 'Last 7 Days (Daily Interval)'),
    useFormatMessage('dashboard.chargerPage.listings.chargerConnectivity.last8weeks', 'Last 8 Weeks (Weekly Interval)'),
  ]
  const connectivityDetailsText = useFormatMessage(
    'dashboard.chargerPage.listings.chargerConnectivity.connectivityDetails',
    'Connectivity Details for {{id}}',
  )
  const selectTimeframeText = useFormatMessage('listings.chargerConnectivity.selectTimeframe', 'Select Timeframe')
  const timeText = useFormatMessage('listings.chargerConnectivity.time', 'Time')
  const scoreText = useFormatMessage('listings.chargerConnectivity.score', 'Score')
  return {
    connectivityPeriods,
    connectivityDetailsText,
    selectTimeframeText,
    timeText,
    scoreText,
  }
}
